import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote: "Anu found a structure two banks had told us wasn't possible — and stayed across every detail right through to settlement.",
    name: "Priya",
    place: "Hawthorn",
  },
  {
    quote: "He treats our business finance like it's his own balance sheet. The annual reviews alone have saved us thousands.",
    name: "Marcus",
    place: "Camberwell",
  },
  {
    quote: "As a doctor with odd hours and complex income, I expected a fight with the banks. Anu made it feel effortless.",
    name: "Dr. Sarah",
    place: "Kew",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Client words</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-ink max-w-2xl leading-[1.1] mb-14">
            Trusted with the <span className="font-editorial italic font-medium text-gold-600">big decisions.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={0.08 * i}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full rounded-3xl bg-paper border border-ink/8 p-8 flex flex-col transition-all duration-500 hover:-translate-y-2 hover:shadow-lift hover:border-gold/50"
              >
                <Quote size={26} className="text-gold mb-6" strokeWidth={1.5} fill="currentColor" />
                <blockquote className="font-editorial italic text-lg text-ink/80 leading-relaxed flex-1">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 pt-6 border-t border-ink/8">
                  <span className="font-display font-bold text-ink text-sm">{t.name}</span>
                  <span className="text-ink/45 text-sm"> · {t.place}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <p className="text-[11px] text-ink/35 mt-8">Sample testimonials — being refreshed with verified client feedback.</p>
      </div>
    </section>
  );
}
